module.exports = __webpack_public_path__ + "img/tiananmen.2ab4dda1.jpg";